// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../images/background-360.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../images/arrow-icon-home.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NotFoundPage_container__QkRdu {
  display: grid;
  justify-items: center;
  height: 100vh;
}
@media (max-width: 700px) {
  .NotFoundPage_container__QkRdu {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: top right;
    background-size: contain;
    background-repeat: no-repeat;
    grid-template-rows: min-content auto min-content;
    justify-items: start;
  }
}
@media (max-width: 500px) {
  .NotFoundPage_container__QkRdu {
    background-size: auto;
  }
}

.NotFoundPage_owner__Yn8Yd {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  justify-content: flex-end;
  margin-bottom: 40px;
  height: auto;
}
@media (max-width: 700px) {
  .NotFoundPage_owner__Yn8Yd {
    flex-direction: row;
    margin: 55px 0 25px 40px;
  }
}
.NotFoundPage_owner_name__vT\\+oZ {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 20px;
  color: #bdbcbc;
}

.NotFoundPage_logo__upvXi {
  margin-top: 40px;
}
@media (max-width: 700px) {
  .NotFoundPage_logo__upvXi {
    flex-direction: row;
    margin: 22px 0 0 40px;
  }
}

.NotFoundPage_content__UoRab {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}
@media (max-width: 700px) {
  .NotFoundPage_content__UoRab {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: auto min-content min-content;
    grid-template-areas: "link_home" "title" "description";
    align-items: end;
    justify-items: start;
    padding-left: 40px;
    gap: 0;
  }
}

.NotFoundPage_title__ptW6y {
  font-family: "Inter";
  font-style: normal;
  font-weight: 800;
  font-size: 220px;
  line-height: 220px;
  color: #080808;
}
@media (max-width: 700px) {
  .NotFoundPage_title__ptW6y {
    grid-area: title;
    font-size: 120px;
  }
}

.NotFoundPage_description__HaBUw {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 25px;
  text-align: center;
  color: #242424;
  text-align: center;
}
@media (max-width: 700px) {
  .NotFoundPage_description__HaBUw {
    grid-area: description;
    text-align: left;
    font-size: 20px;
    margin-top: -30px;
  }
}

.NotFoundPage_link_home__ObX3U {
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 17px;
  line-height: 25px;
  color: #1DB5B6 !important;
  text-align: center;
  margin-top: 20px;
}
@media (max-width: 700px) {
  .NotFoundPage_link_home__ObX3U {
    grid-area: link_home;
    text-align: left;
    margin: 0 0 -30px 0;
    display: flex;
    gap: 15px;
  }
  .NotFoundPage_link_home__ObX3U:before {
    content: "";
    padding-left: 10px;
    background-position: center;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-repeat: no-repeat;
  }
}

.NotFoundPage_description__HaBUw br {
  display: none;
}
@media (max-width: 700px) {
  .NotFoundPage_description__HaBUw br {
    display: block;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/NotFound/NotFoundPage.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,qBAAA;EACA,aAAA;AACF;AACE;EALF;IAMI,yDAAA;IACA,8BAAA;IACA,wBAAA;IACA,4BAAA;IACA,gDAAA;IACA,oBAAA;EAEF;AACF;AAAE;EAdF;IAeI,qBAAA;EAGF;AACF;;AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;AAGF;AADE;EATF;IAUI,mBAAA;IACA,wBAAA;EAIF;AACF;AAFE;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAIJ;;AAAA;EACE,gBAAA;AAGF;AADE;EAHF;IAII,mBAAA;IACA,qBAAA;EAIF;AACF;;AADA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAIF;AAFE;EANF;IAOI,aAAA;IACA,0BAAA;IACA,gDAAA;IACA,sDACA;IAGA,gBAAA;IACA,oBAAA;IACA,kBAAA;IACA,MAAA;EAEF;AACF;;AACA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AAEF;AAAE;EARF;IASI,gBAAA;IACA,gBAAA;EAGF;AACF;;AAAA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AAGF;AADE;EAVF;IAWI,sBAAA;IACA,gBAAA;IACA,eAAA;IACA,iBAAA;EAIF;AACF;;AADA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAIF;AAFE;EAVF;IAWI,oBAAA;IACA,gBAAA;IACA,mBAAA;IACA,aAAA;IACA,SAAA;EAKF;EAHE;IACE,WAAA;IACA,kBAAA;IACA,2BAAA;IACA,yDAAA;IACA,4BAAA;EAKJ;AACF;;AADA;EACE,aAAA;AAIF;AAFE;EAHF;IAII,cAAA;EAKF;AACF","sourcesContent":[".container {\n  display: grid;\n  justify-items: center;\n  height: 100vh;\n\n  @media(max-width: 700px) {\n    background-image: url(\"../../images/background-360.svg\");\n    background-position: top right;\n    background-size: contain;\n    background-repeat: no-repeat;\n    grid-template-rows: min-content auto min-content;\n    justify-items: start;\n  }\n\n  @media(max-width: 500px) {\n    background-size: auto;\n  }\n}\n\n.owner {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  justify-content: flex-end;\n  margin-bottom: 40px;\n  height: auto;\n\n  @media(max-width: 700px) {\n    flex-direction: row;\n    margin: 55px 0 25px 40px;\n  }\n\n  &_name {\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 13px;\n    line-height: 20px;\n    color: #bdbcbc;\n  }\n}\n\n.logo {\n  margin-top: 40px;\n\n  @media(max-width: 700px) {\n    flex-direction: row;\n    margin: 22px 0 0 40px;\n  }\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n\n  @media (max-width: 700px) {\n    display: grid;\n    grid-template-columns: 1fr;\n    grid-template-rows: auto min-content min-content;\n    grid-template-areas:\n    \"link_home\"\n    \"title\"\n    \"description\";\n    align-items: end;\n    justify-items: start;\n    padding-left: 40px;\n    gap: 0;\n  }\n}\n\n.title {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 800;\n  font-size: 220px;\n  line-height: 220px;\n  color: #080808;\n\n  @media (max-width: 700px) {\n    grid-area: title;\n    font-size: 120px;\n  }\n}\n\n.description {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 24px;\n  line-height: 25px;\n  text-align: center;\n  color: #242424;\n  text-align: center;\n\n  @media (max-width: 700px) {\n    grid-area: description;\n    text-align: left;\n    font-size: 20px;\n    margin-top: -30px;\n  }\n}\n\n.link_home {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 17px;\n  line-height: 25px;\n  color: #1DB5B6 !important;\n  text-align: center;\n  margin-top: 20px;\n\n  @media (max-width: 700px) {\n    grid-area: link_home;\n    text-align: left;\n    margin: 0 0 -30px 0;\n    display: flex;\n    gap: 15px;\n\n    &:before {\n      content: '';\n      padding-left: 10px;\n      background-position: center;\n      background-image: url(\"../../images/arrow-icon-home.svg\");\n      background-repeat: no-repeat;\n    }\n  }\n}\n\n.description br {\n  display: none;\n\n  @media (max-width: 700px) {\n    display: block;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `NotFoundPage_container__QkRdu`,
	"owner": `NotFoundPage_owner__Yn8Yd`,
	"owner_name": `NotFoundPage_owner_name__vT+oZ`,
	"logo": `NotFoundPage_logo__upvXi`,
	"content": `NotFoundPage_content__UoRab`,
	"title": `NotFoundPage_title__ptW6y`,
	"description": `NotFoundPage_description__HaBUw`,
	"link_home": `NotFoundPage_link_home__ObX3U`
};
export default ___CSS_LOADER_EXPORT___;
